<template>
  <router-view :key="$route.fullPath"></router-view>
</template>
<script>
  export default {
    name: 'HumanFirewall',
  }
</script>



// WEBPACK FOOTER //
// Root.vue?65d23d31